import './hero.css'
import mobileHeroImg from "../../assets/img/home/mobile_hero_home.png";

const Hero = () => {
	return (
		<section className="hero">
			<div className="container">
				<span className="sub-title">bei Petker's</span>
				<h2 className="title">Pflegenetzwerk in Willebadessen</h2>
				<p className="desc">
					Professionelle Pflege- und Betreuungskräfte in Ihrer Nähe.
				</p>
				<div className="btns-holder">
					<a href="/" className="main-btn t-3">
						Kontakt aufnehmen
					</a>
					<a href="/" className="secondary-btn t-3">
						Mehr erfahren
					</a>
				</div>
			</div>
			<div className="mobile-hero-home">
				<img src={mobileHeroImg} alt="mobile-hero-home" />
			</div>
		</section>
	);
};

export default Hero;
